import { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Accordion, Button, ButtonGroup, Col, Row, Spinner } from "react-bootstrap";
import { FileForm } from "../components/FormItem";
import { datatypelist, DB_TITLE, FileName, FileName2, TITLE} from "../databases/spName";
import { onDownloadFileClick, RemoveFile, UploadFileToFirebase } from "../databases/files";
import { ICON_DOWNLOAD, ICON_PROFILE, ICON_REMOVE, ICON_UPLOAD } from "../components/icons";
import { SettingContext } from "../contexts/SettingContext";
import RenderEditForm from "../components/RenderEditForm";
import { auth } from "../config/firebase";
import { UpdateUser } from "../databases/users";


const RenderUpdateProfile = props => {

    const { onEdit, data, setData, urls, setUrls, isAdminEdit, uid  } = props;

    const setClearDose = (d) => {
        d = parseInt(d)
        let m = {...data}
        for (let i = d + 1; i < 9; i++) {
            m[`dose${i}`] = ''
        }
        m['dose'] = parseInt(d)
        setData(m)
    }

    const setDbfile = async (file, bool) => {
        setData(d => ({...d, [file] : bool }))
        await UpdateUser({ [file] : bool }, uid)
    }


    return (
        <Accordion defaultActiveKey={null} flush>
            {Object.keys(datatypelist).map((datatype, index) => (
                <Accordion.Item key={index} eventKey={datatype} style={{marginTop : datatype === 'document' ? 50 : 0}}>
                    <Accordion.Header>{ICON_PROFILE[datatype]} {datatypelist[datatype]}</Accordion.Header> 
                    {datatype === 'document' ? 
                        <Accordion.Body>
                            <div className="text-center">
                                <img className="d-none d-sm-inline" alt='' src='./images/uploadinstruction.PNG' width='80%' />
                                <img className="d-sm-none" alt='' src='./images/uploadinstruction.PNG' width='100%' />
                            </div>
                            <div className="bold">ข้อแนะนำการอัปโหลดไฟล์</div>
                            <div>1. โปรดคลิก Choose File</div>
                            <div>2. โปรดคลิกลูกศรขึ้น</div>
                            <div>หมายเหตุ : ปุ่มแก้ไขข้อมูล และปุ่มบันทึกด้านบนสุด ไม่เกี่ยวข้องกับส่วนนี้</div>
                            <hr />
                            {Object.keys(FileName2).map((filekey, index) => (
                                <RenderUploadFile 
                                    key={index} filekey={filekey} title={FileName2[filekey]} 
                                    urls={urls} setUrls={setUrls} uid={uid} 
                                    isAdminEdit={isAdminEdit || false} 
                                    dbdata={data[filekey]} setDbfile={setDbfile}
                                /> 
                            ))}
                        </Accordion.Body>
                    :   <Accordion.Body>
                            {DB_TITLE.filter(v => TITLE[v].datatype === datatype).map((field, index) => (
                                <RenderEditForm key={index} 
                                    doseTaken={data['dose']} setClearDose={setClearDose} 
                                    onEdit={onEdit} value={data[field]} field={field} 
                                    onChange={e => setData(m => ({...m, [field] : e.target.value}))} 
                                    isAdminEdit={isAdminEdit || false}
                                />
                            ))}
                            
                        </Accordion.Body>
                    }
                </Accordion.Item>
            ))}
    </Accordion>
    )
}

const RenderUploadFile = props => {

    const { filekey, title, urls, setUrls, uid, isAdminEdit, dbdata, setDbfile } = props
    const [file, setFile] = useState(null)
    const { disabledHiddenList } = useContext(SettingContext)
    const { owndata } = useContext(AuthContext)
    const [isUploading, setUploading] = useState(false)

    useEffect(() => {
        return () => {
            setFile(null)
            setUploading(false);
        }
    }, [])

    const onUploadFileClick = async () => {
        try {
            setUploading(true)
            const url = await UploadFileToFirebase(file, FileName[filekey], uid || auth.currentUser.uid)
            setUrls(u => ({...u, [filekey] : url}))
            await setDbfile(filekey, true)
            setFile(null)
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setUploading(false)
        }
    }

    const onRemoveFileClick = async () => {
        setUploading(true)
        await RemoveFile(FileName[filekey], uid || auth.currentUser.uid)
            .then(() => setDbfile(filekey, false))
            .finally(() => setUploading(false))
        setUrls(u => ({...u, [filekey] : ''}))
    }

    const onSetFileClick = e => {
        if (!e.target.files) {
            alert('ขออภัย ไม่พบไฟล์')
            e.target.value = null
        }
        else if (filekey === 'othdoc') {
            console.log(e.target.files[0])
            if (e.target.files[0].type !== 'application/pdf') {
                alert(`โปรดอัปโหลดนามสกุล pdf`)
                e.target.value = null
            }
            else if (e.target.files[0].size > 4096000) {
                alert(`ขนาดไฟล์ของคุณคือ ${parseInt(e.target.files[0].size / 1000)} KB โปรดอัปโหลดไฟล์ไม่เกิน 4096 KB`)
                e.target.value = null
            }
            else {
                setFile(e.target.files[0])
            }
        }
        else if (e.target.files[0].size > 512000) {
            alert(`ขนาดไฟล์ของคุณคือ ${parseInt(e.target.files[0].size / 1000)} KB โปรดอัปโหลดไฟล์ไม่เกิน 512 KB`)
            e.target.value = null
        }
        else {
            setFile(e.target.files[0])
        }
        
    }

    const isDisabled = useMemo(() => {
        return isAdminEdit ? false : disabledHiddenList[(owndata.round || 0)][filekey].disabled
    }, [isAdminEdit, disabledHiddenList, filekey, owndata.round])

    return (
        <div hidden={disabledHiddenList[(owndata.round || 0)][filekey].hidden}>
            <Row bsPrefix="row align-items-end">
                <Col>
                    <FileForm hidden={urls[filekey]} title={title} onChange={onSetFileClick} disabled={isDisabled}/>
                    <div className="text-success" hidden={!urls[filekey] || !dbdata}>อัปโหลดแล้ว</div>
                    <div className="text-danger" hidden={!urls[filekey] || dbdata}>ขออภัย พบปัญหา โปรดลบแล้วอัปโหลดใหม่!!</div>
                </Col>
                <Col bsPrefix='col-auto mb-3'>
                    <ButtonGroup>
                        <Button variant="light" disabled={typeof file !== 'object' || file === null || isUploading} onClick={onUploadFileClick}>
                            {isUploading ? <Spinner animation="border" size='sm'/> : ICON_UPLOAD}
                        </Button>
                        <Button variant="light" disabled={!urls[filekey] || isUploading} onClick={() => onDownloadFileClick(urls[filekey], `${owndata.flightIndex || ''} ${owndata.nameEN}`)}>
                            {isUploading ? <Spinner animation="border" size='sm'/> : ICON_DOWNLOAD}
                        </Button>
                        <Button variant="light" disabled={!urls[filekey] || isDisabled || isUploading} onClick={onRemoveFileClick}>
                            {isUploading ? <Spinner animation="border" size='sm'/> : ICON_REMOVE}
                        </Button>
                    </ButtonGroup>

                </Col>
            </Row>
            <hr />
        </div>
    )
}


export default RenderUpdateProfile;